<template>
  <dl
    class="product-box show-flex-box-c"
    :class="{'course-border':routerInfo == 'course_store','mars-box-border':routerInfo == 'marsbox_store'}"
    @click="jumpProduct(productObj.id)"
  >
    <dt class="product-pic show-flex-box-r">
      <span class="show-flex-box-r">
        <img :src="productObj.logo" draggable="false">
      </span>
    </dt>
    <dd class="title show-flex-box-r">
      <span>{{productObj.name}}</span>
    </dd>
    <dd class="tag show-flex-box-r" v-if="routerInfo == 'marsbox_store'">
      <span>{{productObj.summary}}</span>
    </dd>
    <dd class="product-info show-flex-box-r">
      <span class="price show-flex-box-r" v-if="routerInfo == 'marsbox_store'">
        <strong>¥{{checkProductionPrice(productObj.prices)}}</strong>
        <h2
          v-if="productObj.prices.min.org && productObj.prices.max.org"
        >¥{{productObj.prices.max.org}}</h2>
      </span>
      <span class="price show-flex-box-r" v-else>
        <strong>¥{{productObj.prices.current}}</strong>
        <h2 v-if="productObj.prices.org">¥{{productObj.prices.org}}</h2>
      </span>
      <span class="sales-volume show-flex-box-r">
        销量:
        <strong>{{productObj.sale}}</strong>
      </span>
    </dd>
  </dl>
</template>

<script>
export default {
  name: "product_purchase_introduction_cpn",
  data() {
    return {
      routerInfo: ""
    };
  },
  props: {
    productObj: [Number, String, Object]
  },
  created() {
    this.reqRouterPath();
  },
  methods: {
    checkProductionPrice: function(allPrices) {
      //价格判断
      if (allPrices.min.current == allPrices.max.current) {
        return allPrices.min.current;
      } else {
        return allPrices.min.current + "~" + "¥" + allPrices.max.current;
      }
    },
    reqRouterPath: function() {
      this.routerInfo = this.$route.name;
    },
    jumpProduct: function(id) {
      if (this.routerInfo) {
        let toWhere = "/mars_box_store/" + this.routerInfo + "/detail/store";
        this.$router.push({ path: toWhere, query: { id: id } });
      }
    }
  },
  watch: {
    $route: function(from) {
      this.reqRouterPath();
    }
  }
};
</script>

<style scoped lang="less">
.product-box {
  overflow: hidden;
  width: 230px;
  height: 330px;
  border-radius: 10px;
  background: rgba(254, 254, 254, 1);
  transition: 0.3s;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  .product-pic {
    overflow: hidden;
    // flex-shrink: 0;
    width: 230px;
    height: 229px;
    border-bottom: 1px solid #ff5d00;
    span {
      overflow: hidden;
      flex-grow: 1;
      img {
        display: block;
        width: 100%;
        height: 100%;
        flex-grow: 1;
        object-fit: cover;
      }
    }
  }
  .title {
    align-items: center;
    padding: 10px 9px;
    overflow: hidden;
    span {
      font-size: 18px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #191d21;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .tag {
    padding-left: 9px;
    align-items: center;
    span {
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #ff7800;
      padding: 3px 2px;
      border: 1px solid #ff7800;
      border-radius: 5px;
    }
  }
  .product-info {
    justify-content: space-between;
    padding: 11px 27px 14px 9px;
    .price {
      font-size: 12px;
      font-weight: 500;
      color: #ff6700;
      align-items: baseline;
      white-space: nowrap;
      & > strong {
        display: block;
        font-size: 18px;
        font-weight: 500;
        color: #ff6700;
        padding-right: 5px;
      }
      & > h2 {
        display: block;
        font-size: 14px;
        font-weight: 500;
        color: #8c8c8c;
        text-decoration: line-through;
      }
    }
    .sales-volume {
      align-items: flex-end;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #8c8c8c;
      white-space: nowrap;
      strong {
        color: #49d963;
      }
    }
  }
}
.product-box:hover {
  box-shadow: 0px 1px 30px 0px rgba(0, 0, 0, 0.1);
}
.course-border {
  border: 1px solid #e5e5e5;
}
.mars-box-border {
  border: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/mars_box_store/common/product_purchase_introduction_cpn.vue